import request from '@/util/request';
import qs from 'qs';

export const removeMenu = (params, options) =>
request.post('/api/v4ward/knowledgeMenu/remove', qs.stringify(params),options);

export const addMenu = (params, options) =>
request.post('/api/v4ward/knowledgeMenu/save', params,options)

export const updateMenu = (params, options) =>
request.post('/api/v4ward/knowledgeMenu/update', params,options)

export const getMenuTree = (projectId,tenantId) => {
  return request({
    url: '/api/v4ward/knowledgeMenu/tree',
    method: 'get',
    params: {
      projectId,
      tenantId,
    },
  });
};

export const getMenuLazyTree = (projectId,parentId) => {
  return request({
    url: '/api/v4ward/knowledgeMenu/lazy-tree',
    method: 'get',
    params: {
      projectId,
      parentId,
    },
  });
};


export const getKnowledgeList = (params, options) =>
  request.get('/api/v4ward/knowledgeDetail/list', Object.assign({}, options, { params }));

export const getKnowledgeDetail = (params, options) =>
  request.get('/api/v4ward/knowledgeDetail/detail', Object.assign({}, options, { params }))

export const removeKnowledge = (params, options) =>
  request.post('/api/v4ward/knowledgeDetail/remove', qs.stringify(params),options);

export const addKnowledge = (params, options) =>
  request.post('/api/v4ward/knowledgeDetail/save', params,options)

export const checkOk = (params, options) =>
  request.post('/api/v4ward/knowledgeDetail/checkOk', params,options)

export const checkReject = (params, options) =>
  request.post('/api/v4ward/knowledgeDetail/checkReject', params,options)



